import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { InternalServerError } from '@core/http/models/internal-server-error';
import { NZ_MODAL_DATA, NzModalFooterDirective, NzModalRef, NzModalTitleDirective } from 'ng-zorro-antd/modal';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'rais-internal-server-error-modal',
    templateUrl: './internal-server-error-modal.component.html',
    styleUrls: ['./internal-server-error-modal.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NzModalTitleDirective,
        NzModalFooterDirective,
        NzIconModule,
        NzDescriptionsModule,
        DatePipe
    ]
})
export class InternalServerErrorModalComponent {
  errorObj: InternalServerError = inject<InternalServerError>(NZ_MODAL_DATA);
  now = new Date();

  constructor(private nzModalRef: NzModalRef) {
    console.log('InternalServerErrorModalComponent ctor');
    // this.nzModalRef.getConfig().nzTitle = 'Внутренняя ошибка сервера';
  }
}
